import React from 'react';
import { MediaAttachment } from 'src/shared/types/src';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import MediaCarouselContainer from '../commonComponents/mediaCarousel/MediaCarouselContainer';

type IProps = {
    showMediaCarouselModal: boolean,
    toggleMediaCarouselModal: () => void,
    media: MediaAttachment[]
}

const MediaCarouselModal: React.FC<IProps> = ({ showMediaCarouselModal, toggleMediaCarouselModal, media }) => {

    return (
        <Modal 
            isOpen={showMediaCarouselModal} 
            toggle={toggleMediaCarouselModal} 
            backdrop={true} 
            centered={true}
            className='custom-modal-md'
            scrollable={window.innerWidth > 767 ? true : false }
        >
            <ModalHeader toggle={toggleMediaCarouselModal}></ModalHeader>
            <ModalBody className='pd-b-15'>
                <MediaCarouselContainer
                    media={media}
                />
            </ModalBody>
        </Modal>
    );
};

export default MediaCarouselModal;